// These line icons are for the small buttons of links and sections. Each icon is
// a path on a 16×16 grid. The CSS draws all paths with the text color and with
// one stroke width, so all icons have the same weight.
const PATHS = {
  collapsed: "M6 3.5 10.5 8 6 12.5",
  expanded: "M3.5 6 8 10.5 12.5 6",
  open: "M5 11 11 5M6.5 5H11v4.5",
  menu: "M3.5 8a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0M7.5 8a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0M11.5 8a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0",
  locked: "M4 7.5h8V13H4zM5.75 7.5V5.75a2.25 2.25 0 0 1 4.5 0V7.5",
  unlocked: "M4 7.5h8V13H4zM5.75 7.5V4.25a2.25 2.25 0 0 1 4.5 0",
};

export type IconName = keyof typeof PATHS;

const SVG = "http://www.w3.org/2000/svg";

export function icon(name: IconName): SVGSVGElement {
  const svg = document.createElementNS(SVG, "svg");
  svg.setAttribute("viewBox", "0 0 16 16");
  svg.setAttribute("aria-hidden", "true");
  const path = document.createElementNS(SVG, "path");
  path.setAttribute("d", PATHS[name]);
  svg.appendChild(path);
  return svg;
}
